/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const collectionNarrowV3Schema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  publishedChallengesCount: z.number(),
  posterUrl: z.string().nullable(),
  backdropUrl: z.string().nullable(),
  updatedAt: z.number(),
});

export type ICollectionV3 = z.infer<typeof collectionNarrowV3Schema>;

export const getPublicCollectionBySlugV3ResponseSchema = createApiResponseSchema(
  collectionNarrowV3Schema,
) as z.ZodSchema<IAPI<ICollectionV3>>;

export type IGetPublicCollectionBySlugV3Response = IAPI<ICollectionV3>;
